import { useRef } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import './ConfirmationDialog.scss';
import ButtonWithSpinner from '../buttons/ButtonWithSpinner';
import { filterUndefined } from '../../utils/FilterUndefinedObject';

/**
 * Confirmation dialog component.
 * Dialogs inform users about a task and can contain critical information, require decisions
 */
const defaultProps = {
  open: false,
  title: null,
  confirmLabel: 'OK',
  cancelLabel: 'Cancel',
  confirmClass: '',
  cancelClass: '',
  loading: false,
  autoFocusCancelButton: true,
};

export default function ConfirmationDialog(props) {
  const {
    open,
    title,
    contentText,
    confirmLabel,
    cancelLabel,
    onConfirm,
    onCancel,
    confirmClass,
    cancelClass,
    loading,
    autoFocusCancelButton,
    ...rest
  } = { ...defaultProps, ...filterUndefined(props) };
  const cancelButtonRef = useRef(null);
  const confirmButtonRef = useRef(null);

  return (
    <Dialog
      {...rest}
      open={open}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      {
        title
          ? <DialogTitle className='vizzle-dialog-title' data-test='title'>{title}</DialogTitle> : ''
      }
      <DialogContent>
        <div className='vizzle-dialog-content' data-dd-privacy='mask'>
          {contentText}
        </div>
      </DialogContent>
      <DialogActions className='vizzle-dialog-actions'>
        <ButtonWithSpinner
          label={cancelLabel}
          onClick={onCancel}
          ref={cancelButtonRef}
          color='primary'
          data-test='confirm-dialog-cancel-button'
          className={`vizzle-dialog-actions-cancel btn-danger ${cancelClass}`}
          loading={loading}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onCancel();
            } else if (e.key === 'Tab') {
              e.preventDefault();
              confirmButtonRef.current.focus();
            }
          }}
          autoFocus={autoFocusCancelButton}
        />
        <ButtonWithSpinner
          label={confirmLabel}
          onClick={onConfirm}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onConfirm();
            } else if (e.key === 'Tab') {
              e.preventDefault();
              cancelButtonRef.current.focus();
            }
          }}
          ref={confirmButtonRef}
          color='primary'
          data-test='confirm-dialog-confirm-button'
          className={`vizzle-dialog-actions-confirm btn-primary ${confirmClass}`}
          loading={loading}
        />
      </DialogActions>
    </Dialog>
  );
}
